import { atom, selector } from 'recoil';
import { PageConfig } from '@app/config';

/**
 *
 */
type initialRecoilState = {
  // Global
  isFirstVisit: boolean;
  pageConfig: PageConfig;

  // PDP Only
  defaultSizeId?: string | null;
  productId?: string | null;
  selectedSize?: string | number | null;
  variantId?: string | null;

  isSizePickerVisible?: boolean;
  isVariant?: boolean;
};

/**
 * Stores a global representation of very first initial set of data provided by either the window
 * or the request object.
 */
const initialStateData = atom<initialRecoilState>({
  key: 'app.initial',
  default: undefined,
});

/**
 * Global PageConfig
 */
export const defaultPageConfig = selector<PageConfig>({
  key: 'app.initial.default.pageConfig',
  get: ({ get }) => {
    const initial = get(initialStateData);
    return initial?.pageConfig ?? {};
  },
});

/**
 * Currently unused but required for few pirate projects
 */
export const defaultIsFirstVisit = selector<boolean>({
  key: 'app.initial.default.isFirstVisit',
  get: ({ get }) => {
    const initial = get(initialStateData);
    return initial?.isFirstVisit ?? false;
  },
});

/**
 * PDP / defaultDefaultSizeId
 */
export const defaultDefaultSizeId = selector<string | null>({
  key: 'app.initial.default.defaultSizeId',
  get: ({ get }) => {
    const initial = get(initialStateData);
    return initial?.defaultSizeId ?? null;
  },
});

/**
 * PDP / isSizePickerVisible
 */
export const defaultIsSizePickerVisible = selector<boolean>({
  key: 'app.initial.default.isSizePickerVisible',
  get: ({ get }) => {
    const initial = get(initialStateData);
    return initial?.isSizePickerVisible ?? false;
  },
});

/**
 * PDP / isVariant
 */
export const defaultIsVariant = selector<boolean>({
  key: 'app.initial.default.isVariant',
  get: ({ get }) => {
    const initial = get(initialStateData);
    return initial?.isSizePickerVisible ?? false;
  },
});

/**
 * PDP / isVariant
 */
export const defaultProductId = selector<string | null>({
  key: 'app.initial.default.productId',
  get: ({ get }) => {
    const initial = get(initialStateData);
    return initial?.productId ?? null;
  },
});

/**
 * PDP / selectedSize
 */
export const defaultSelectedSize = selector<string | number | null>({
  key: 'app.initial.default.selectedSize',
  get: ({ get }) => {
    const initial = get(initialStateData);
    return initial?.selectedSize ?? null;
  },
});

/**
 * PDP / variantId
 */
export const defaultVariantId = selector<string | null>({
  key: 'app.initial.default.variantId',
  get: ({ get }) => {
    const initial = get(initialStateData);
    return initial?.variantId ?? null;
  },
});

export default initialStateData;
